export default {
    edit: 'Editar',
    location: 'Localização + T&C',
    filter: 'Filtrar',
};
